import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import WaivePromoterFundModalUI from './WaivePromoterFundModalUI.js'

class WaivePromoterFundModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      waivePromoterFund: '',
      waivePromoterFundError: null
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <WaivePromoterFundModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        booleanList={booleanList}
        waivePromoterFund={this.state.waivePromoterFund}
        onWaivePromoterFundChange={(event) => { this.setState({ waivePromoterFund: event.target.value }) }}
        waivePromoterFundError={this.state.waivePromoterFundError}
        setWaivePromoterFundError={(error) => { this.setState({ waivePromoterFundError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/updatePromoterFund`,
      this.onSubmitCallback, {
      waivePromoterFund: this.state.waivePromoterFund
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(WaivePromoterFundModalSF)
